import { toNumberList, type DrawnNumbers, type DrawnNumbersSource } from './getRevealedNumbers';

function intersect(owned: number[], revealed: number[]): number[] {
  return owned.filter(number => revealed.includes(number));
}

/**
 * Ticket (or pooled) numbers that appear in the revealed prefix.
 *
 * Daily Million only — does not apply lottery-specific matching rules (for example Irish Lotto
 * folding the bonus ball into main-number matching). Not barrel-exported until those rules are
 * applied here.
 *
 * Revealed state lives on `useLiveDraw().revealedNumbers`. Your Numbers matches against that
 * prefix — not the full API payload.
 */
function getMatchedNumbers(owned: DrawnNumbersSource, revealed: DrawnNumbers): DrawnNumbers {
  const numbers = intersect(toNumberList(owned.numbers), revealed.numbers);

  if (owned.extraNumbers === undefined && revealed.extraNumbers === undefined) {
    return { numbers };
  }

  return {
    numbers,
    extraNumbers: intersect(toNumberList(owned.extraNumbers), toNumberList(revealed.extraNumbers)),
  };
}

function hasMatchedNumbers(matched?: Partial<DrawnNumbers> | null): boolean {
  return Boolean(matched?.numbers?.length || matched?.extraNumbers?.length);
}

export { getMatchedNumbers, hasMatchedNumbers };
